import { createSelector } from 'reselect'
import featureScopesSelector from './featureScopesSelector'

const isVehicleCodeEnabledSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('audicode'),
)

export default isVehicleCodeEnabledSelector
